import axios, { AxiosError } from "axios"

type Error = {
  code: string
  detail: string
}

// this is format that comes from our backend
type ErrorResponse = {
  errors: Error[]
}

const generalFallback = "Something went wrong"

type Args = {
  error: AxiosError
  fallback?: string
}

const extractErrorCode = (errorResponse: ErrorResponse, fallback?: string) => {
  if (!errorResponse.errors || !errorResponse.errors.length) {
    return fallback || generalFallback
  }
  return errorResponse.errors[0].code
}

export const extractAxiosError = ({ error, fallback }: Args): string => {
  if (!axios.isAxiosError(error)) {
    // unexpected error occurred
    return generalFallback
  }

  const typedError = error as AxiosError
  const errorResponse = typedError.response!.data as ErrorResponse
  return extractErrorCode(errorResponse, fallback)
}
